import { useFormContext } from 'framework/form';
import { EXPENSE_SUBTYPES_ALIASES, EXPENSE_TYPES } from 'domain/shared/expense';
import useSharedLeaveService from 'domain/shared/leave/leaveService';
import LeaveDropdown, { LeaveDropdownProps } from 'domain/shared/leave/input/LeaveDropdown';
import { LEAVE_STATUSES_ALIASES } from 'domain/shared/leave/constants';

interface ExpensesLeaveDropdownProps extends LeaveDropdownProps {
  employeeSource?: string;
  typeSource?: string;
}

const LEAVE_TYPES = EXPENSE_SUBTYPES_ALIASES[EXPENSE_TYPES.LEAVE_COMPENSATION];

const ExpensesLeaveDropdown = ({ employeeSource, typeSource, ...props }: ExpensesLeaveDropdownProps) => {
  const { searchAllWithExpensesInfo } = useSharedLeaveService();
  const { data = {} } = useFormContext();
  const employeeAlias = employeeSource ? data[employeeSource] : undefined;
  const type = typeSource && data[typeSource] !== LEAVE_TYPES.MATERNITY_LEAVE ? data[typeSource] : undefined;
  const filter: Dictionary<any> = {
    status: { in: [LEAVE_STATUSES_ALIASES.APPROVED, LEAVE_STATUSES_ALIASES.REGISTERED] },
    'employee.alias': { eq: employeeAlias },
  };

  if (type === LEAVE_TYPES.PAID_LEAVE) {
    filter.type = { in: ['PAID_LEAVE', 'COMPENSATION'] };
  } else if (type) {
    filter.type = { in: [type] };
  }

  return (
    <LeaveDropdown
      {...props}
      deps={[employeeAlias, type]}
      filter={filter}
      isVisible={!!typeSource && data[typeSource] !== LEAVE_TYPES.MATERNITY_LEAVE}
      loadDataMethod={searchAllWithExpensesInfo}
    />
  );
};

export default ExpensesLeaveDropdown;
